import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs"

export const shortVideoDetailsApi = createAsyncThunk(
    'auth/shortVideos/detail',
    async (id, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.shortVideosAction(`${id}`, 1))
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)
const intialState = { result: [], loading: false, error: null, message: "" }
const shortVideoDetailsSlice = createSlice({
    name: 'shortVideo detail',
    initialState: { result: [], loading: false, error: null, message: "" },
    reducers: {
        resetShortVideo: () => intialState,
    },
    extraReducers: (builder) => {
        builder.addCase(shortVideoDetailsApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(shortVideoDetailsApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(shortVideoDetailsApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})
export const { resetShortVideo } = shortVideoDetailsSlice.actions;
export const shortVideoDetailsReducer = shortVideoDetailsSlice.reducer